import { Empresa } from '../entities/empresa';
export class DTOInformacaoUsuario{ 
    public IdUsuario: number;    
    public NomeUsuario: string;
    public CpfUsuario: string;
    public Empresa: Empresa;
    public Perfil: string;    
    public Email: string;  
    public NomeEmpresaUsuario: string;   
    public CnpjEmpresaUsuario: string;  
    public CodRepresetante: number;
    public NomeRepresetante: string;
    public IdentificacaoLoja: string;   
    public Fone: string; 
    public Senha: string;
    public DtAniversario: Date;
    public Informativo: boolean;

    deserialize(input: Object): DTOInformacaoUsuario {
        Object.assign(this, input);
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoInfomacaoUsuario.ts